import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';

interface IListBoxProps {
    children: React.ReactElement[];
    role: string;
    onMouseDown: React.MouseEventHandler;
}

const Component: React.FC<IListBoxProps> = ({
    children,
    role,
    onMouseDown,
}: IListBoxProps) => {
    return (
        <List className="autocomplete__list" role={role}>
            {children.map((item) => (
                <ListItem className="autocomplete__list-item">
                    <ListItemButton
                        className="autocomplete__list-item-btn"
                        onMouseDown={onMouseDown}
                    >
                        {item}
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    );
};

const ListComponent = React.memo(Component);

export default ListComponent;
